import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h3>Sundhari Vasthra is live! 💌</h3>
      </header>
    </div>
  );
}

export default App;
